import { CanActivateFn } from '@angular/router';
import {AuthService} from './auth-service';
import {inject} from '@angular/core';

export const authGuard: CanActivateFn = (route, state): boolean | Promise<boolean> => {
  const authService = inject(AuthService);

  if (authService.isAlreadyLoggedIn()) {
    return true;
  }

  authService.login();
  return false;
};
